<template>
  <div class="header">
    <div class="nav">
      <div>
        <ProgressiveImage
          container-class="logo"
          :src="logo_jpg"
          :avif="logo_avif"
          :webp="logo_webp"
          alt="Yous Link Logo"
          no-fade
        />
      </div>
      <div class="nav-right">
        <ul>
          <li @click="openTab(1)">
            <router-link :class="[routhPath.id == 1 ? 'active-font' : '', 'font']" to="/"
              >HOME</router-link
            >
          </li>
          <li @click="openTab(2)">
            <span :class="[routhPath.id == 2 ? 'active-font' : '', 'font']" class="font"
              >SALES</span
            >
          </li>
          <li @click="openTab(3)">
            <router-link :class="[routhPath.id == 3 ? 'active-font' : '', 'font']" to="/letting"
              >LETTINGS</router-link
            >
          </li>
          <li @click="openTab(4)">
            <span :class="[routhPath.id == 4 ? 'active-font' : '', 'font']" class="font"
              >MANAGEMENT</span
            >
          </li>
          <!-- <li @click="openTab(5)">
            <span :class="[routhPath.id == 5  ? 'font active-font' : 'font']" class="font">RENT</span>
          </li> -->
          <li @click="openTab(6)">
            <span :class="[routhPath.id == 6 ? 'font active-font' : 'font']">ABOUT</span>
          </li>
        </ul>
      </div>
    </div>
    <div class="tab" v-if="activeMenu">
      <ul class="tab-ul">
        <li :style="{ 'padding-right': activeMenu.offset }">
          <template v-for="(link, index) in activeMenu.menu">
            <span
              class="span"
              v-if="link.name == 'span'"
              :key="link.name + index"
              :style="{ right: link.offset }"
            ></span>
            <div
              v-else-if="link.name == 'link'"
              :key="link.name + index + ''"
              class="tab-link pdf"
              @click="openPdf(link.path)"
            >
              {{ link.title }}
            </div>
            <router-link
              v-else
              :key="link.name"
              :class="[routhPath.name == link.name ? 'active-font ' : '', 'tab-link', 'link']"
              :to="link.path"
              >{{ link.title }}</router-link
            >
          </template>
        </li>
      </ul>
    </div>

    <div class="mobile-nav">
      <div class="item" @click="closeIcon">
        <ProgressiveImage
          container-class="mobile-logo"
          :src="logo_jpg"
          :avif="logo_avif"
          :webp="logo_webp"
          alt="Yous Link Logo"
        />
        <ProgressiveImage v-if="drawer" container-class="mobile-item" :src="close_svg" />
        <ProgressiveImage
          v-else
          container-class="mobile-item"
          :src="item_menu_png"
          :avif="item_menu_avif"
          :webp="item_menu_webp"
        />
      </div>
      <el-drawer
        class="drawer"
        title=" "
        :with-header="false"
        :visible.sync="drawer"
        :direction="direction"
        :before-close="handleClose"
        :modal="false"
      >
        <div class="menu-group-wrapper">
          <div :default-active="$route.path" class="menu-group" router @close="handleClose">
            <div class="menu-item menu-main" index="/index" @click="go('/index')">HOME</div>
            <div class="menu-item menu-main" index="2" @click="onClickMainMenu(2)">SALES</div>
            <transition name="collaspe">
              <div class="menu-sub-wrapper" v-if="activeTab == 2">
                <div class="menu-item menu-sub" index="/sale" @click="go('/sale?page=1')">
                  Resale Property
                </div>
                <div class="menu-item menu-sub" index="/newHome" @click="go('/newHome?page=2')">
                  New Homes
                </div>
                <div class="menu-item menu-sub" index="/book" @click="go('/book')">
                  Property Valuation
                </div>
                <div class="menu-item menu-sub" index="/why" @click="go('/why')">Why Yourslink</div>
              </div>
            </transition>
            <div class="menu-item menu-main" index="/letting" @click="go('/letting')">LETTINGS</div>
            <div class="menu-item menu-main" index="4" @click="onClickMainMenu(4)">MANAGEMENT</div>
            <transition name="collaspe">
              <div class="menu-sub-wrapper" v-if="activeTab == 4">
                <div class="menu-item menu-sub" index="/management" @click="go('/management')">
                  Management
                </div>
                <div
                  class="menu-item menu-sub"
                  index="/privacy-policy"
                  @click="go('/privacy-policy')"
                >
                  Privacy Policy
                </div>
              </div>
            </transition>
            <div class="menu-item menu-main" index="/service" @click="go('/service')">ABOUT US</div>
          </div>
        </div>
      </el-drawer>
    </div>
  </div>
</template>

<script>
import * as allIcons from '@assets/images/icon';
import { Drawer } from 'element-ui';

export default {
  name: 'navComponent',
  components: {
    'el-drawer': Drawer,
  },
  props: ['indexPath'],
  data() {
    return {
      logo_jpg: allIcons.logo,
      logo_avif: allIcons.logoAvif,
      logo_webp: allIcons.logoWebp,
      close_svg: allIcons.close,
      item_menu_png: allIcons.itemMenu,
      item_menu_avif: allIcons.itemMenuAvif,
      item_menu_webp: allIcons.itemMenuWebp,

      routhPath: {},
      direction: 'rtl',
      drawer: false,
      activeTab: 'none',
      menuMap: {
        2: {
          offset: '8.3rem',
          menu: [
            { name: 'buying2', title: 'Resale Property', path: '/sale?page=2' },
            { name: 'buying1', title: 'New Homes', path: '/newHome?page=1' },
            { name: 'span', offset: '72%' },
            { name: 'book', title: 'Property Valuation', path: '/book' },
            { name: 'why', title: 'Why Yourslink', path: '/why' },
          ],
        },
        4: {
          offset: '6rem',
          menu: [
            { name: 'management', title: 'Management', path: '/management' },
            { name: 'privacyPolicy', title: 'Privacy Policy', path: '/privacy-policy' },
            { name: 'span', offset: '64%' },
          ],
        },
        // 5: {
        //   offset: '7.3rem',
        //   menu: [
        //     { name: 'rentList', title: 'Properties To Rent', path: '/rentList' },
        //     { name: 'parkingSpace', title: 'Parking Space To Rent', path: '/parkingSpace' },
        //     { name: 'other', title: 'Other Service', path: '/otherService' },
        //   ],
        // },
        6: {
          offset: '',
          menu: [
            { name: 'about', title: 'About Us', path: '/service' },
            { name: 'JoinUs', title: 'Join Us', path: '/join-us' },
            {
              name: 'link',
              title: 'Client Money Handling Procedures',
              path: 'https://cdn.yourslink.co.uk/Yours%20Link-Client%20Money%20Handling%20Procedures.pdf',
            },
            {
              name: 'link',
              title: 'CMP Membership Certificate',
              path: 'https://cdn.yourslink.co.uk/CMP.pdf',
            },
            {
              name: 'link',
              title: 'Complaints Procedure',
              path: 'https://cdn.yourslink.co.uk/Yours%20Link_Complaints%20Procedure.pdf',
            },
            { name: 'span', offset: '14%' },
          ],
        },
      },
    };
  },
  computed: {
    activeMenu() {
      if (!this.activeTab) return null;
      const target = this.menuMap[this.activeTab];
      if (!target) return null;
      return target;
    },
  },
  mounted() {
    this.routhPath = this.indexPath;
    console.log(`routhPath => `, this.routhPath);
  },
  methods: {
    openTab(id) {
      this.activeTab = id;
      const whiteList = [2, 4, 5, 6];
      if (whiteList.includes(id)) {
        this.routhPath.id = id;
      } else {
        this.routhPath.id = '';
      }
      console.log(`routhPath 2 => `, this.routhPath, this.activeTab);
    },
    closeIcon() {
      this.drawer = !this.drawer;
    },
    openPdf(url) {
      window.open(url, '_blank');
    },
    handleClose() {
      this.drawer = false;
    },
    go(link) {
      this.$router.push(link);
    },
    onClickMainMenu(tab) {
      this.activeTab = tab;
    },
  },
};
</script>

<style scoped lang="scss">
.font {
  font-family: PuHuiTiRegular;
}

.active-font {
  color: var(--c-primary) !important;
}

.header {
  position: relative;
  // top: 0;
  z-index: 9999;

  background-color: #fff;
}

.nav {
  width: 60rem;
  margin: 0 auto;
  height: 4.5rem;
  display: flex;
  justify-content: space-between;
}

.logo {
  width: 7.25rem;
  height: 4.85rem;
  position: absolute;
  z-index: 999;
}

.nav-right {
  ul {
    display: flex;

    li {
      margin-top: 1.1rem;
      margin-left: 2rem;
      line-height: 3.4rem;

      a {
        color: $font;
      }

      span:hover {
        color: $bgcolor;
        cursor: pointer;
      }
    }

    li:hover {
      a {
        color: $bgcolor;
      }
    }
  }
}

.tab {
  width: 100%;
  height: 3rem;
  line-height: 3rem;
  background-color: #f5f5f5;
  position: absolute;
  top: 4.5rem;
  z-index: 99;

  .tab-ul {
    width: 70rem;
    margin: 0 auto;
    display: flex;
    font-size: 0.8rem;
    justify-content: right;

    li {
      // width: 40.25rem;
      display: flex;
      justify-content: right;
      position: relative;

      span {
        width: 1rem;
        height: 1rem;
        display: block;
        position: absolute;
        top: -0.4rem;
        transform: rotate(45deg);
        -webkit-transform: rotate(45deg);
        -moz-transform: rotate(45deg);
        -o-transform: rotate(45deg);
        background-color: #f5f5f5;
      }
    }

    .span {
      position: absolute;
    }

    .rent-tab {
      span {
        position: absolute;
        top: -0.4rem;
        left: 24.8rem;
      }
    }

    .tab-link {
      white-space: nowrap;
      color: #333;
    }

    .tab-link:not(:last-child) {
      margin-right: 1.65rem;
    }

    .tab-link2 {
      margin-right: 1.65rem;
    }

    .link {
      cursor: pointer;
    }

    .pdf {
      color: #333;
      cursor: pointer;
    }

    .link:hover {
      color: $bgcolor;
    }
  }
}

.mobile-nav {
  display: none;
}

@media only screen and (max-width: 1280px) {
  .nav {
    display: none;
  }

  .drawer {
    margin-top: 5rem;
  }

  .tab {
    display: none;
  }

  .mobile-nav {
    display: block;
    width: 100%;
    height: 5rem;
    position: sticky;
    top: 0;
    z-index: 999; // dialog 2003
    background: #2b4eb4;

    .item {
      display: flex;
      width: 100%;
      padding: 2rem;
      justify-content: space-between;
      align-items: center;
      height: 5rem;
    }

    .mobile-logo {
      width: 6.8rem;
      height: 4.6rem;
    }

    .mobile-item {
      width: 1.6rem;
      height: 1.5rem;
    }

    .menu-group-wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      padding-top: 10%;
      color: var(--c-text);
    }

    .menu-group {
      width: inherit;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
    }

    .menu-item {
      padding: 1rem 4rem;
      font-size: x-large;
      text-align: center;
    }
    .menu-main {
      font-weight: bold;
    }

    .menu-item.active {
      color: var(--c-primary);
    }
  }
}
</style>
<style>
.el-drawer {
  min-width: 100%;
}
</style>
